import "./index.scss";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import AppShell from "../../components/appShell";
import TeamCards from "../../components/teamCards";
import {
  selectisLoggedIn,
  selectTeamsData,
  teams as getTeams,
} from "../../store/features/curatorSlice";

const TeamList = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();
  let isLoggedin = useSelector(selectisLoggedIn);
  let teams = useSelector(selectTeamsData);

  useEffect(() => {
    dispatch(getTeams());
  }, []);

  if (!isLoggedin) {
    return (
      <AppShell role="public">
        <h1 className="au-heading">Not signed in</h1>
        <p className="au-subheading">
          <Link to="/curator/login">Sign in as a curator</Link> to see the
          teams.
        </p>
      </AppShell>
    );
  }

  return (
    <AppShell role="curator">
      <header className="team-list-head">
        <div>
          <h1 className="au-heading">Teams</h1>
          <p className="au-subheading">
            Every squad as it stands, by role. Open slots are the ones still to
            fill.
          </p>
        </div>
        <button
          type="button"
          className="au-btn ghost"
          onClick={() => navigate("/curator/auction")}
        >
          Back to auction room
        </button>
      </header>

      {teams?.length ? (
        <div className="team-grid">
          {teams.map((team) => (
            <TeamCards
              key={team?._id || team?.name}
              team={team?.team}
              teamColor={team?.color?.hex}
              secondaryTeamColor={team?.secondaryColor}
              teamName={team?.name}
              filteredPlayerData={team?.filteredPlayers}
            />
          ))}
        </div>
      ) : (
        <p className="au-empty">No teams yet.</p>
      )}
    </AppShell>
  );
};

export default TeamList;
